import { getEnvDisplayedName, isProd } from "@utils/environment";

export const EnvBanner = () => {
  if (isProd) {
    return null;
  }

  return (
    <div className="lf-pointer-events-none lf-fixed lf-top-0 lf-right-0 lf-left-0 lf-z-[100] lf-bg-[var(--red-9)] lf-px-1 lf-text-center lf-text-[9px] lf-font-bold lf-tracking-wider lf-text-white lf-uppercase">
      {getEnvDisplayedName()}
    </div>
  );
};
